// Filter chips with counts (design/isomorphic runs): one pressed at a time.
import { cn } from "./cn";

export interface Chip<K extends string> {
  key: K;
  label: string;
}

export function FilterChips<K extends string>({
  chips,
  value,
  counts,
  onChange,
  label,
  className,
}: {
  chips: readonly Chip<K>[];
  value: K;
  counts: Record<K, number>;
  onChange: (key: K) => void;
  label: string;
  className?: string;
}) {
  return (
    <div className={cn("custom-scrollbar flex gap-2 overflow-x-auto pb-1", className)} role="group" aria-label={label}>
      {chips.map((f) => (
        <button
          key={f.key}
          type="button"
          aria-pressed={value === f.key}
          onClick={() => onChange(f.key)}
          className={cn(
            "inline-flex shrink-0 items-center gap-2 rounded-full border px-3.5 py-1.5 text-[13px] font-medium transition-colors",
            value === f.key ? "border-primary bg-primary text-primary-foreground" : "border-muted bg-gray-0 text-gray-700 hover:border-gray-300 dark:bg-gray-50",
          )}
        >
          {f.label}
          <span className={cn("tabular rounded-full px-1.5 text-[11px]", value === f.key ? "bg-white/20" : "bg-gray-100 text-gray-600")}>
            {counts[f.key]}
          </span>
        </button>
      ))}
    </div>
  );
}
